import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { MaterialModule } from '../../../material/material.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-settings',
  imports: [CommonModule, MaterialModule, RouterModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent {
  constructor(private location: Location) {}

  back(): void {
    this.location.back();
  }

  isScoutAdmin(): boolean {
    const rawRoles = localStorage.getItem('userRoles');
    if (!rawRoles) {
      return false;
    }

    try {
      const parsedRoles = JSON.parse(rawRoles) as string[];
      return Array.isArray(parsedRoles) && parsedRoles.includes('Scouting_Admin');
    } catch {
      return rawRoles.includes('Scout_Admin');
    }
  }


  isUserAdmin(): boolean {
    const rawRoles = localStorage.getItem('userRoles');
    if (!rawRoles) {
      return false;
    }

    try {
      const parsedRoles = JSON.parse(rawRoles) as string[];
      return Array.isArray(parsedRoles) && parsedRoles.includes('User_Admin');
    } catch {
      return rawRoles.includes('User_Admin');
    }
  }

}
